export const CARD_ACTIVITY_PER_PAGE = 9;
